'use strict';

function getCJEvent() {
    let url = new URL(window.location.href),
        urlParams = new URLSearchParams(window.location.search), // Get cjevent from URL
        cjEvent = urlParams.get('cjevent');

    // Skip Thank You / Confirmation page
    if (url.pathname.toLowerCase().indexOf('orderconfirmation') > -1) {
        return;
    }

    if (cjEvent) {
        $.ajax({
            url: window.SFRA.Urls.setCJCookie,
            type: 'GET',
            data: {
                cjevent: cjEvent
            },
            error: function (e) {
                console.log('CJ Cookie Failed: ', e);
            }
        });
    }
}

getCJEvent();
